<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <card>
            <v-spacer/>

            <v-dialog
              v-model="dialog"
              persistent
              max-width="768px">
              <template v-slot:activator="{ on }">
                <v-layout>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <base-button
                      :color="color"
                      class="mb-2"
                      v-on="on">
                      New Category
                    </base-button>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <base-input
                      v-model="search"
                      :loading="loading"
                      label="Search"
                      placeholder="Search..."
                      hide-details/>
                  </v-flex>
                </v-layout>
              </template>
              <each-category
                :edited-index="editedIndex"
                :item="editedItem"
                :key="editedIndex"
                @update="updateCategory"
                @create="createCategory"
              />

              <category-tags
                v-if="editedItem.id"
                :category_id="editedItem.id"
                :key="editedItem.id"/>
              <v-spacer/>
              <base-button
                @click="close">Close</base-button>
            </v-dialog>

            <v-data-table
              :headers="headers"
              :items="CategoryList"
              :pagination.sync="pagination"
              :rows-per-page-items ="rowsAmount"
              :search="search"
              :light="false"
              class="table table-striped"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr @click="pushCategoryIdToUrl(props.item)">
                  <td>{{ props.item.id }}</td>
                  <td> {{ props.item.name }} </td>
                  <td> {{ props.item.description }} </td>
                  <td> {{ props.item.display_order }} </td>
                  <td> <v-icon v-if="props.item.active">check</v-icon></td>
                  <td class="justify-center ">
                    <i
                      class="tim-icons icon-pencil pointer"
                      @click="pushCategoryIdToUrl(props.item)"/>
                    &nbsp;&nbsp;
                    <i
                      class="tim-icons icon-trash-simple pointer"
                      @click="deleteItem(props.item)"/>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import BaseButton from '@/components/BaseButton'
import EachCategory from '@/components/DashViews/EachCategory'
import CategoryTags from '@/components/DashViews/CategoryTags'

export default {
  components: { CategoryTags, EachCategory, BaseButton },
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    pagination: {
      sortBy: 'display_order'
    },
    CategoryList: [

    ],
    loading: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,
    search: '',
    headers: [
      {
        text: 'Id',
        align: 'left',
        value: 'id'
      },
      {
        text: 'Name',
        align: 'left',
        value: 'name'
      },
      {
        text: 'Description',
        align: 'left',
        value: 'description'
      },
      {
        text: 'Display Order',
        align: 'left',
        value: 'display_order'
      },
      {
        text: 'Active',
        align: 'left',
        value: 'active'
      },
      {
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }
    ],
    editedIndex: -1,
    editedItem: {
      id: '',
      name: '',
      description: '',
      active: true
    },
    defaultItem: {
      id: '',
      name: '',
      description: '',
      active: true
    }
  }),

  computed: {
    ...mapState('app', ['color']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Category' : 'Edit Category'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    '$route.params.search': {
      handler: function (search) {
        this.search = search
      },
      deep: true,
      immediate: true
    }
    // '$route.query.id': {
    //   handler: function(id) {
    //     console.log('route change ' + id)
    //    this.reactToCategoryChange(id);
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  // called when page is created before dom
  created () {
    this.index()
  },
  methods: {
    reactToCategoryChange: function (id) {
      for (var i = 0; i < this.CategoryList.length; i++) {
        if (this.CategoryList[i].id === id) {
          this.editItem(this.CategoryList[i])
          return
        }
      }
    },
    addParamsToLocation (params) {
      history.pushState(
        {},
        null,
        this.$route.path +
          '?' +
          Object.keys(params)
            .map(key => {
              return (
                encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
              )
            })
            .join('&')
      )
    },
    pushCategoryIdToUrl: function (cat) {
      this.addParamsToLocation({ id: cat.id })
      this.editItem(cat)
    },
    updateCategory (item) {
      Object.assign(this.CategoryList[this.editedIndex], item)
      this.saveInline()
    },
    createCategory (item) {
      this.CategoryList.unshift(item)
      this.saveInline()
      this.close()
    },
    index () {
      this.$store.state.spinning = true
      let self = this
      axios.get('/categories')
        .then(response => {
          self.CategoryList = response.data
          self.$store.state.spinning = false
          if (self.$route.query.id) {
            self.reactToCategoryChange(this.$route.query.id)
            this.$router.push('categories')
          }
        })
        .catch(err => {
          if (err.response.status == '403') {
            this.showError('Unauthorized')
          } else {
            this.showError(JSON.stringify(err.response.data.errors))
          }
          self.$store.state.spinning = false
        })
    },

    // object.assign fills in the empty object with the properties of item
    editItem (item, dbox = true) {
      this.editedIndex = this.CategoryList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = dbox
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline
        })
    },

    deleteItem (item) {
      const index = this.CategoryList.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        this.$store.state.spinning = true
        axios.delete('/categories/' + item.id)
          .then((response) => {
            this.CategoryList.splice(index, 1)
            this.deleteInline()
            this.close()
            this.$store.state.spinning = false
          }
          )
          .catch(error => {
            if (error && error.response && error.response.status == '403') {
              this.showError('Unauthorized')
            } else {
              this.showError(JSON.stringify(error.response.data.errors))
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Category saved'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Category deleted'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    reset () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
